module.exports = __webpack_public_path__ + "img/SJ.d91702a1.svg";